import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "services/api";
import { ResumedView } from "./ResumedView";
import { IMovimentacao } from "../types";
import { DetailedView } from "./DetailedView";

export function View() {
  const { workspaceId, templateId } = useParams() as { workspaceId: string, templateId: string };
  const [view, setView] = useState<"RESUMED" | "DETAILED">("RESUMED");

  function handleChangeView(newView: "RESUMED" | "DETAILED") {
    setView(newView);
  }

  const { data, isLoading, isError } = useQuery({
    queryKey: ["movimentacao-atividade", workspaceId, templateId],
    queryFn: () =>
      api.get(
        `/v2/workspaces/${workspaceId}/templates/${templateId}/movimentacao`
      ),
    select: (data) => data.data.data as IMovimentacao,
    refetchInterval: 5000
  });

  return (
    <>
      {isLoading && <div>Loading...</div>}
      {isError && <div>Error...</div>}
      {data && view === "RESUMED" && (
        <ResumedView
          movimentacao={data.movimentacao}
          template={data.template}
          setViewMode={handleChangeView}
        />
      )}
      {data && view === "DETAILED" && (
        <DetailedView
          template={data.detailedView}
          setViewMode={handleChangeView}
        />
      )}
    </>
  );
}
